import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    standalone: false
})
export class LogoutComponent implements OnInit {

	public loading = false;
	constructor(
		protected dialogRef: NbDialogRef<LogoutComponent>,
		protected router: Router,
	) { }

	ngOnInit(): void { }

	public logoutAction(): void {
		this.loading = true;
		this.dialogRef.close({ validated: true });
	}

	public closeAction(): void {
		this.dialogRef.close({ validated: false });
	}
}
